/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

.patient-education-button {
  width: 100%;
  justify-content: space-between;
  color: variables.$color-black;
  padding: 12px 12px;

  .patient-education-title {
    font-size: 14px;
    font-weight: 500;
    max-width: 200px; // We need a specific width here to have ellipsis
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
